import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: block;
  position: relative;
  margin-bottom: 20px;
`;

export const BirthBox = styled.div`
  display: flex;
  gap: 4px;

  & > div {
    &:nth-of-type(1),
    &:nth-of-type(2) {
      flex: 1;
      min-width: 45px;
    }

    &:nth-of-type(3) {
      flex: 2;
    }
  }
`;

export const InputBox = styled.div`
  ${({ theme }) => css`
    display: block;
    position: relative;
    width: 100%;
    height: 44px;
    padding: 11px 12px;
    overflow: hidden;
    border-radius: 8px;
    background: ${theme.backgroundColor.bg_dark_3};
  `}
`;

export const Input = styled.input`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    color: ${theme.content.content_light_1};
    line-height: 22px;
    ${theme.fontStyle.text.body16_medium}

    &::placeholder {
      color: ${theme.content.content_light_5};
      ${theme.fontStyle.text.body16_medium};
    }
  `}
`;

export const NotiText = styled.div`
  ${({ theme }) => css`
    display: block;
    margin-top: 3px;
    ${theme.fontStyle.text.caption_medium}
    color: ${theme.content.content_light_3};
  `}
`;

export const MobileSelectBox = styled.div`
  display: block;
  position: relative;
`;

export const MobileSelect = styled.select`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    padding: 11px 12px;
    border: none;
    border-radius: 8px;
    outline: none;
    background: ${theme.backgroundColor.bg_dark_3};
    color: ${theme.content.content_light_1};
    font-family: 'Pretendard';
    line-height: 22px;
    ${theme.fontStyle.text.body16_medium}
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &.placeholder {
      color: ${theme.content.content_light_5};
    }

    & > option[value=''][disabled] {
      display: none;
      color: ${theme.content.content_light_5};
    }
  `}
`;

export const StyledIcon = styled.div`
  display: block;
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
`;
